import {
  Button,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@material-ui/core";
import { Link } from "@backstage/core-components";
import { useRouteRef } from "@backstage/core-plugin-api";
import { agentPoliciesPlugin } from "@internal/plugin-agent-policies";
import SecurityIcon from "@material-ui/icons/Security";
import { useRootStyles } from "../../styles/useRootStyles";

interface AgentPoliciesNavItemProps {
  mobile?: boolean;
  onClick?: () => void;
}

export const AgentPoliciesNavItem = ({
  mobile = false,
  onClick,
}: AgentPoliciesNavItemProps) => {
  const agentPoliciesPath = useRouteRef(agentPoliciesPlugin.routes.root);
  const classes = useRootStyles();

  if (!agentPoliciesPath) {
    return null;
  }

  if (mobile) {
    return (
      <ListItem
        button
        component={Link}
        to={agentPoliciesPath()}
        className={classes.drawerItem}
        onClick={onClick}
      >
        <ListItemIcon className={classes.drawerIcon}>
          <SecurityIcon />
        </ListItemIcon>
        <ListItemText primary="Agent Policies" />
      </ListItem>
    );
  }

  return (
    <Button
      component={Link}
      to={agentPoliciesPath()}
      className={classes.navButton}
      startIcon={<SecurityIcon />}
      color="inherit"
    >
      Agent Policies
    </Button>
  );
};
